// actionTypes.js
export const GET_USER = "GET_USER";
